import {
  createFileUploadStore,
  FileUploadStoreOptions,
} from '@common/uploads/uploader/file-upload-store';
import {useWorkspaceStore} from '@common/workspace/workspace-store';
import {getBootstrapData} from '@ui/bootstrap-data/bootstrap-data-store';
import {create} from 'zustand';

/**
 * One Drive upload queue for the whole tab (build 128).
 *
 * Created once at module level, above the router, so navigating between
 * Drive, admin, account settings or any other page never unmounts it and
 * running uploads keep going.
 */
export const DRIVE_UPLOADS_PERSIST_KEY = 'drive';

export const driveUploadStoreOptions: FileUploadStoreOptions = {
  persistUploads: true,
  persistKey: DRIVE_UPLOADS_PERSIST_KEY,
  modifyUploadedFile: uploadedFile => {
    const workspaceId = useWorkspaceStore.getState().activeWorkspace?.id;
    uploadedFile.fingerprint = `${uploadedFile.fingerprint}-w-${workspaceId}`;
    return uploadedFile;
  },
};

let store: ReturnType<typeof createFileUploadStore> | null = null;

export function driveUploadStore() {
  if (!store) {
    store = createFileUploadStore({
      settings: getBootstrapData().settings,
      options: driveUploadStoreOptions,
    });
  }
  return store;
}

interface UploadPanelState {
  // Panel is shown at all (expanded or as the pill).
  visible: boolean;
  // Expanded list vs. compact floating pill.
  expanded: boolean;
  open: () => void;
  minimize: () => void;
  expand: () => void;
  close: () => void;
}

export const useUploadPanel = create<UploadPanelState>()(set => ({
  visible: false,
  expanded: true,
  open: () => set({visible: true, expanded: true}),
  minimize: () => set({visible: true, expanded: false}),
  expand: () => set({visible: true, expanded: true}),
  close: () => set({visible: false, expanded: true}),
}));
